import request from './request';

const GET_PACKAGE_CLAIM_RECORDS = 'amp2.MrmsSrv/GetGiftRecord';
const GET_PACKAGE_CLAIM_RECORDS_FLOW_3 = 'action/api/common/queryDeliverResource';
const GET_PACKAGE_CLAIM_RECORDS_BY_AMS_ODD_NUMBER = 'action/api/common/awardRecord';
const GET_PACKAGE_CLAIM_RECORDS_CJM = 'prod01/amp2.MrmsSrv/GetGiftRecord';
const FLOW_VERSION_3 = 2;
const GET_QUERY_CDK_TYPE = '/action/api/common/v2/queryCdkType';
export default class ClaimRecord {
  static async getClaimRecords(params) {
    // 是都根据ams单号来查询获奖记录
    if (params?.moduleId) {
      return request.post(GET_PACKAGE_CLAIM_RECORDS_BY_AMS_ODD_NUMBER, params);
    }
    if (params?.flow_version && params.flow_version === FLOW_VERSION_3) {
      return request.post(GET_PACKAGE_CLAIM_RECORDS_FLOW_3, params);
    }
    // 区分和平精英
    if (params?.business_id === 'cjm' && window.CEIBA_ENV !== 'test') {
      return request.post(GET_PACKAGE_CLAIM_RECORDS_CJM, params);
    }
    return request.post(GET_PACKAGE_CLAIM_RECORDS, params);
  }
  static async getQueryCdkType(params) {
    return request.post(GET_QUERY_CDK_TYPE, { ...params });
  }
}
